export const SUPPORT_EMAIL = 'customer-care@elora.lu';
export const SUPPORT_EMAIL_MAILTO = `mailto:${SUPPORT_EMAIL}`;
